import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const PurcheshesList = () => {
    const [purcheshes, setPurcheshes] = useState([]);
    const [filteredPurcheshes, setFilteredPurcheshes] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${BASE_URL}purcheshes`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setPurcheshes(data.data);
                    setFilteredPurcheshes(data.data);
                } else {
                    console.error('Error fetching purcheshes:', data.message);
                }
            })
            .catch(error => console.error('Error fetching purcheshes:', error));
    }, []);

    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        const filtered = purcheshes.filter(purchese =>
            purchese.pcs_weight.toString().includes(term) ||
            purchese.price.toString().includes(term)
        );
        setFilteredPurcheshes(filtered);
    };

    const handleEdit = (id) => {
        navigate(`/EditPurchesh/${id}`);
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this purchese?")) {
            fetch(`${BASE_URL}purcheshes/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        setPurcheshes(purcheshes.filter(purchese => purchese.id !== id));
                        setFilteredPurcheshes(filteredPurcheshes.filter(purchese => purchese.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting purchese:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Purcheshes List</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6"></div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={() => navigate('/AddPurcheshes')}>Add Purchese</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Weight or Price</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search by weight or price"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>STAFF ID</th>
                                                <th>VEPARI ID</th>
                                                <th>WEIGHT</th>
                                                <th>PRICE</th>
                                                <th>TOTAL</th>
                                                <th>IMAGE</th>
                                                <th className="text-end">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredPurcheshes.map(purchese => (
                                                <tr key={purchese.id}>
                                                    <td>{purchese.staff_id}</td>
                                                    <td>{purchese.vepari_id}</td>
                                                    <td>{purchese.pcs_weight}</td>
                                                    <td>{purchese.price}</td>
                                                    <td>{purchese.total}</td>
                                                    <td>
                                                        <img src={`${BASE_URL}${purchese.image}`} alt="Purchese" style={{ width: '50px' }} />
                                                    </td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(purchese.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(purchese.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PurcheshesList;
